module.exports = __webpack_public_path__ + "static/img/20009 (5).130fe1d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20009 (5).webp
// module id = ybYC
// module chunks = 14